// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__kNmtI"};